module.exports = __webpack_public_path__ + "static/media/chat.d56048cd.svg";